import styled from 'styled-components'

import { _2XL_Bold, _M_Medium, _S_Medium, _XS_Normal, mainColors } from '@avantstay/backoffice-core'

import { ErrorBanner as BaseErrorBanner } from '@new/__ui/AIChat/AIChat.styles'

// Session gate ("continue or start fresh") and session picker styles.

export const ErrorBanner = styled(BaseErrorBanner)`
  margin: 0 20px 12px;
`

export const GateActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 320px;
  margin-top: 8px;
`

export const PrimaryButton = styled.button`
  ${_S_Medium}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: ${mainColors.accentDark};
  color: ${mainColors.white};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background: ${mainColors.accentExtraDark};
  }

  &:disabled {
    background: ${mainColors.neutralMedium};
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
  }
`

export const SecondaryButton = styled.button`
  ${_S_Medium}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid ${mainColors.neutralMedium};
  background: ${mainColors.white};
  color: ${mainColors.neutralExtremelyDark2};
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${mainColors.accentLight};
    color: ${mainColors.accentDark};
    background: ${mainColors.accentExtremelyLight};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
  }
`

export const Picker = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  padding: 20px;
  overflow-y: auto;
`

export const PickerTitle = styled.div`
  ${_2XL_Bold}
  color: ${mainColors.primaryMedium};
`

export const SessionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`

export const SessionItem = styled.button`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid ${mainColors.neutralMedium};
  background: ${mainColors.white};
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${mainColors.accentLight};
    background: ${mainColors.accentExtremelyLight};
  }

  &:disabled {
    opacity: 0.7;
    cursor: default;
  }
`

export const SessionTitle = styled.div`
  ${_M_Medium}
  color: ${mainColors.primaryMedium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SessionMeta = styled.div`
  ${_XS_Normal}
  color: ${mainColors.neutralExtraDark};
`
